import { render, staticRenderFns } from "./users.vue?vue&type=template&id=9b20931e&scoped=true"
import script from "./users.vue?vue&type=script&setup=true&lang=js"
export * from "./users.vue?vue&type=script&setup=true&lang=js"
import style0 from "./users.vue?vue&type=style&index=0&id=9b20931e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b20931e",
  null
  
)

export default component.exports